import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators as bind} from 'redux';
import fields from '../../constants/fieldsForRenewalSubmissionForm';
import * as submissionInfoActions from '../../actions/submissionInfoActions';
import { postRenewalSubmissionAttachments } from '../../actions/attachmentActions';
import Form from '../common/Form/Form';
import RenewalSubmissionFormUploadInstructions from './RenewalSubmissionFormUploadInstructions';
import { totalSections } from '../../lib/sectionUtils';
import sharedProps from '../common/Form/SharedFormProps';
import { sharedDispatchToProps, sharedStateToProps } from '../common/Form/SharedReduxToProps';

const progressText = {
  1: {
    line1: 'Financing',
    line2: 'Information'
  },
  2: {
    line1: 'Upload',
    line2: 'Documents'
  }
};

export class RenewalSubmissionForm extends Component {
  constructor() {
    super();

    this.totalSections = totalSections(progressText);
  }

  render() {
    const { dba, submission: {notes = ""}, uuid } = this.props;

    return (
      <Form
        {...this.props}
        fields={fields}
        postSubmission={() => this.props.postRenewalSubmissionInfo({
          ...this.props.submission,
          uuid,
          notes
        })}
        progressText={progressText}
        title={`Renewal Submission: ${dba}`}
        totalSections={this.totalSections}
        uploadInstructions={<RenewalSubmissionFormUploadInstructions />}
      />
    );
  }
}

RenewalSubmissionForm.propTypes = {
  ...sharedProps,
  postRenewalSubmissionInfo: PropTypes.func.isRequired,
  uuid: PropTypes.string
};

function mapStateToProps(state) {
  return sharedStateToProps(state);
}

function mapDispatchToProps(dispatch) {
  return {
    postRenewalSubmissionInfo: bind(
      submissionInfoActions.postRenewalSubmissionInfo,
      dispatch
    ),
    postSubmissionAttachments: bind(
      postRenewalSubmissionAttachments, dispatch
    ),
    ...sharedDispatchToProps(dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RenewalSubmissionForm);
